import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import { Nav, NavItem } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap/lib';
import buildMenu from './menuBuilder';
import './DealerNav.scss';

class DealerNav extends PureComponent {
  renderMenuItem = (item) => {
    const url = item.getUrl(this.props.dealer.id);
    return (
      <LinkContainer to={url} key={url} className="nav-link-container ">
        <NavItem>{item.name}</NavItem>
      </LinkContainer>
    );
  };

  render() {
    const { user } = this.props;
    const menu = buildMenu(user);
    return <Nav bsStyle="tabs">{menu.map(this.renderMenuItem)}</Nav>;
  }
}

DealerNav.propTypes = {
  dealer: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = ({ dealers, user }) => ({
  dealer: dealers.dealer,
  user: user.currentUser,
});

export default connect(mapStateToProps)(DealerNav);
